<template>
    <b-modal ref="mdlEditSetting" id="mdlEditSetting" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">{{ getLabelTraduora("nurity.accettazione.setting") }}</label>
                <b-form-input v-model="jsonDataSetting.setting"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice</label>
                <b-form-input v-model="jsonDataSetting.codice"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-input v-model="jsonDataSetting.note" placeholder="Inserire note"> </b-form-input>
            </b-col>
        </b-row>

        <template #modal-footer>
            <b-button @click="onCloseModal" variant="outline-danger" size="md"> Annulla</b-button>
            <b-button @click="onSaveSetting" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/rsasettings",
            jsonDataSetting: {
                id: null,
                setting: null,
                codice: null,
                note: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.jsonDataSetting = jsonData;
            me.title = !jsonData.id ? "Nuovo " + this.getLabelTraduora("nurity.accettazione.setting") : "Aggiorna " + this.getLabelTraduora("nurity.accettazione.setting");
            me.$refs.mdlEditSetting.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataSetting = {};
            me.$refs.mdlEditSetting.hide();
            me.$emit("closeModal");
        },

        onSaveSetting() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataSetting, me.saveSettingSuccess, me.saveSettingError);
        },

        saveSettingSuccess(response) {
            this.$emit("onSave", response);
            this.$refs.mdlEditSetting.hide();
            this.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveSettingError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
    },
};
</script>
